'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _iBemReact = require('@yandex-lego/i-bem-react');

exports.default = (0, _iBemReact.decl)({
    block: 'button2',
    elem: 'icon',
    render: function render() {
        var block = this.block,
            elem = this.elem,
            _props = this.props,
            children = _props.children,
            side = _props.side,
            size = _props.size;

        return (0, _react.cloneElement)(children, {
            size: size,
            mix: [].concat(children.props.mix, { block: block, elem: elem, mods: { side: side } })
        });
    }
});